export default "__VITE_ASSET__boL4OGhD__"